import React, { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next/';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

import { useIsMobile } from '@hooks/index';

import classes from './TableOfContents.module.scss';
import Props, { TableOfContentsItem } from './TableOfContents.props';
import TextLink from '@components/ui/TextLink/TextLink';
import Card from '@components/ui/Card/Card';

const TableOfContents = ({ items, className }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isOpen, setOpen] = useState(!isMobile);

  const renderToggle = () => {
    const label = isOpen
      ? t('COMPONENTS.TABLE_OF_CONTENTS.HIDE_CONTENTS')
      : t('COMPONENTS.TABLE_OF_CONTENTS.SHOW_CONTENTS');

    return (
      <div
        className={cn(classes.Toggle, { [classes.Open]: isOpen })}
        onClick={() => setOpen(!isOpen)}>
        <span className={classes.ToggleLabel}>{label}</span>{' '}
        <FontAwesomeIcon className={classes.Icon} icon={faChevronDown} />
      </div>
    );
  };

  const renderItem = (item: TableOfContentsItem, key: number) => (
    <li key={key}>
      <TextLink onClick={item.onClick} theme="tertiary">
        {item.label}
      </TextLink>
    </li>
  );

  const renderItems = () => {
    return items.map(renderItem);
  };

  return (
    <div className={cn(classes.TableOfContents, className)}>
      <Card className={classes.HeadWrapper} innerClassName={classes.Head}>
        <div className={classes.Title}>{t('COMPONENTS.TABLE_OF_CONTENTS.CONTENT')}</div>
        {renderToggle()}
      </Card>
      <Card className={cn(classes.Content, { [classes.Open]: isOpen })} hasBackground>
        {isOpen && <ol className={classes.List}>{renderItems()}</ol>}
      </Card>
    </div>
  );
};

export default TableOfContents;
